export default __webpack_public_path__ + "static/experienceImg2-3f3c1de6bd6bb2a9ea1465bb76ee8faf.png";